





















import {Vue, Component, Watch, Prop} from "vue-property-decorator";

@Component
export default class RiskSubText extends Vue {
    @Prop() private stepNumber!: any;
    @Prop() private title!: any;
    @Prop() private subTitle!: any;
    @Prop() private text1!: any;
    @Prop() private text2!: any;
}
